export default "/images/c4f2cba6794d4c6ae909204250945886.png";